import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import API_ENDPOINTS from '../api/apiConfig';

function Contact() {
    const location = useLocation();

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: '',
    });
    const [loading, setLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        document.querySelectorAll('.set-bg').forEach(el => {
            const bg = el.getAttribute('data-setbg');
            if (bg) el.style.backgroundImage = `url('/${bg}')`;
        });
    }, []);

    useEffect(() => {
        if (location.state?.service) {
            setFormData(prev => ({ ...prev, service: location.state.service }));
        }
    }, [location.state]);

    const handleChange = e => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = async e => {
        e.preventDefault();
        setLoading(true);
        setSuccessMsg('');
        setErrorMsg('');

        try {
            const payload = {
                name: formData.name,
                email: formData.email,
                phone: formData.phone,
                ...(formData.service && { service: formData.service }),
                ...(formData.message && { message: formData.message }),
            };

            const response = await fetch(API_ENDPOINTS.CREATECONTACTREQUEST, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (data.status) {
                setSuccessMsg('Your message has been sent successfully! We will get back to you soon.');
                setFormData({ name: '', email: '', phone: '', service: '', message: '' });
            } else {
                setErrorMsg(data.message || 'Something went wrong. Please try again.');
            }
        } catch (err) {
            setErrorMsg('Network error. Please check your connection and try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
        <div className="breadcrumb-option contact-breadcrumb set-bg" data-setbg="img/breadcrumb/callreq.webp">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <div className="breadcrumb__text">
                            <h2>Contact Us</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section className="contact spad">
            <div className="container">
                <div className="contact__form">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="contact__form__text">
                                <div className="contact__form__title">
                                    <h2>Get In Touch</h2>
                                    <p>Please contact us or send us an email or go to our forum.</p>
                                </div>

                                {/* Success / Error Messages */}
                                {successMsg && (
                                    <div style={{ padding: '12px 15px', marginBottom: '20px', background: '#e6f9f0', border: '1px solid #52c41a', borderRadius: '4px', color: '#389e0d' }}>
                                        {successMsg}
                                    </div>
                                )}
                                {errorMsg && (
                                    <div style={{ padding: '12px 15px', marginBottom: '20px', background: '#fff2f0', border: '1px solid #ff4d4f', borderRadius: '4px', color: '#cf1322' }}>
                                        {errorMsg}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    <div className="input-list">
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="Your name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Your email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <input
                                        type="tel"
                                        name="phone"
                                        placeholder="Your contact number"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                        pattern="[0-9]{10}"
                                        title="Enter a valid 10-digit mobile number"
                                        style={{ width: '100%', padding: '12px 15px', marginBottom: '20px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '15px', outline: 'none' }}
                                    />

                                    <select
                                        name="service"
                                        value={formData.service}
                                        onChange={handleChange}
                                        required={!!location.state?.service}
                                        style={{ width: '100%', padding: '12px 15px', marginBottom: '20px', border: '1px solid #e0e0e0', borderRadius: '4px', fontSize: '15px', color: formData.service ? '#333' : '#999', background: '#fff', outline: 'none' }}
                                    >
                                        <option value="">Select a Service (optional)</option>
                                        <option value="personal">Personal Loan</option>
                                        <option value="business">Business Loan</option>
                                        <option value="loan_against_property">Loan Against Property</option>
                                        <option value="credit_card">Credit Card</option>
                                        <option value="balance_transfer">Balance Transfer / Top-Up</option>
                                        <option value="gold">Gold Loan</option>
                                        <option value="car">Car Loan</option>
                                        <option value="home">Home Loan</option>
                                        <option value="insurance">Insurance</option>
                                    </select>

                                    <textarea
                                        name="message"
                                        placeholder="Your Message (optional)"
                                        value={formData.message}
                                        onChange={handleChange}
                                    ></textarea>

                                    <button type="submit" className="site-btn" disabled={loading}>
                                        {loading ? 'Sending...' : 'Send Message'}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-6">
                        <div className="contact__address__item">
                            <h4>Surat</h4>
                            <ul>
                                <li><i className="fa fa-map-marker"></i> 203A Sovereign shopper NR, Sindhu Seva Samiti School, Adajan, 395009</li>
                                <li><i className="fa fa-phone"></i> +91 6354894678</li>
                                <li><i className="fa fa-envelope"></i> support@vijayprimes.com</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6">
                        <div className="contact__address__item">
                            <h4>Silvassa</h4>
                            <ul>
                                <li><i className="fa fa-map-marker"></i> 1st Floor, Shop No 5, Jalaram Complex, Opp Jama Masjid, ITI Road, Silvassa, 396230</li>
                                <li><i className="fa fa-phone"></i> +91 6354894678</li>
                                <li><i className="fa fa-envelope"></i> support@vijayprimes.com</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    );
}

export default Contact;